const userRoles = [
  {
    label: 'Member',
    value: 'member',
  },
  {
    label: 'Manager',
    value: 'manager',
  },
];

export default userRoles;
